import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { BiMenu, BiMenuAltRight } from "react-icons/bi"
import { Menu, Transition, Popover } from "@headlessui/react"
import { FaChevronDown, FaChevronUp } from "react-icons/fa"
const Header = ({ siteTitle, menu }) => {
  return (
    <header className="absolute top-0 left-0 w-full z-50">
      <div className="max-w-6xl  mx-auto w-11/12 lg:w-[95%] xl:w-full py-4">
        <div className="flex items-center justify-between">
          <div>
            <Link to="/">
              <StaticImage
                src="../../images/logo.png"
                className="h-20 w-36 lg:h-20 lg:w-36 xl:h-[6.9rem] xl:w-48 drop-shadow"
                quality={100}
                alt="The Orchid Group"
              />
              <span className="sr-only">{siteTitle}</span>
            </Link>
          </div>
          <Popover>
            {({ open }) => (
              <>
                <Popover.Button
                  as="button"
                  className="block lg:hidden text-4xl p-2 bg-white rounded border-l-4 border-primary/40 text-primary shadow-lg shadow-secondry/50"
                >
                  {!open ? <BiMenu /> : <BiMenuAltRight />}
                </Popover.Button>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Popover.Panel
                    as="div"
                    className="block lg:hidden  absolute w-full top-28 left-0"
                  >
                    <ul className="w-11/12 mx-auto rounded-lg overflow-hidden bg-white border-l-4 shadow-lg shadow-primary/40 border-primary/40 divide-y divide-secondry/40 text-sm uppercase tracking-widest">
                      {menu.map((me, key) => {
                        return (
                          <li
                            key={key}
                            className={`block w-full hover:bg-stone-100 overflow-hidden ${
                              me.drop ? "pl-4" : "px-4"
                            }`}
                          >
                            {me.drop ? (
                              <>
                                <Menu>
                                  {({ open }) => (
                                    <>
                                      <div className="flex justify-between">
                                        <Link
                                          to={me.to}
                                          className="block w-9/12  p-3"
                                        >
                                          {me.title}
                                        </Link>

                                        <Menu.Button className="w-3/12 bg-secondry text-primary flex justify-center items-center">
                                          {open ? (
                                            <FaChevronDown />
                                          ) : (
                                            <FaChevronUp />
                                          )}
                                        </Menu.Button>
                                      </div>
                                      <Transition
                                        as={Fragment}
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 translate-y-4"
                                        enterTo="transform opacity-100 translate-y-0"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 translate-y-0"
                                        leaveTo="transform opacity-0 translate-y-4"
                                      >
                                        <Menu.Items
                                          as="ul"
                                          className="relative bg-stone-50 border-t border-stone-300 w-full"
                                        >
                                          {me.drop.map((m, key) => {
                                            return (
                                              <Menu.Item
                                                as="li"
                                                key={key}
                                                className="w-full flex py-3 px-2 text-stone-900 hover:bg-stone-300 shadow-md shadow-stone-500/20"
                                              >
                                                <a
                                                  className="w-full"
                                                  href={m.to}
                                                >
                                                  {m.title}
                                                </a>
                                              </Menu.Item>
                                            )
                                          })}
                                        </Menu.Items>
                                      </Transition>
                                    </>
                                  )}
                                </Menu>
                              </>
                            ) : me.href ? (
                              <a
                                href={me.href}
                                target="_blank"
                                rel="noreferrer"
                                className="block w-full  p-3"
                              >
                                {me.title}
                              </a>
                            ) : (
                              <Link to={me.to} className="block w-full  p-3">
                                {me.title}
                              </Link>
                            )}
                          </li>
                        )
                      })}
                    </ul>
                  </Popover.Panel>
                </Transition>
              </>
            )}
          </Popover>
          <nav className="hidden lg:block text-white text-xs md:text-[0.830rem]">
            <ul className="flex items-center space-x-6">
              {menu.map((me, key) => {
                return (
                  <li key={key} className="flex space-x-2 uppercase">
                    {me.href ? (
                      <a href={me.href} target="_blank" rel="noreferrer">
                        {me.title}
                      </a>
                    ) : (
                      <Link to={me.to}>{me.title}</Link>
                    )}

                    {me.drop && (
                      <Menu>
                        {({ open }) => (
                          <>
                            <Menu.Button>
                              {open ? <FaChevronDown /> : <FaChevronUp />}
                            </Menu.Button>
                            <Transition
                              as={Fragment}
                              enter="transition ease-out duration-100"
                              enterFrom="transform opacity-0 -translate-y-3"
                              enterTo="transform opacity-100 translate-y-0"
                              leave="transition ease-in duration-75"
                              leaveFrom="transform opacity-100 translate-y-0"
                              leaveTo="transform opacity-0 -translate-y-3"
                            >
                              <Menu.Items
                                as="ul"
                                className="absolute mt-8 bg-stone-100 border-l-4 border-stone-400 max-w-[12.5rem] w-full -translate-x-12"
                              >
                                {me.drop.map((m, key) => {
                                  return (
                                    <Menu.Item
                                      as="li"
                                      key={key}
                                      className="w-full flex py-2 px-2 text-stone-900 hover:bg-stone-300"
                                    >
                                      <a
                                        className="w-full truncate"
                                        href={m.to}
                                      >
                                        {m.title}
                                      </a>
                                    </Menu.Item>
                                  )
                                })}
                              </Menu.Items>
                            </Transition>
                          </>
                        )}
                      </Menu>
                    )}
                  </li>
                )
              })}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}
Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
